import React from 'react'
import Link from 'next/link'

import {t} from '@lib/helpers'

const CTA = () => {
  return (
    <section className='Landing__cta'>
      <div className='Landing__cta__card'>
        <h2 className='Landing__cta__h2'>{t('pages.index.landing.cta.h2')}</h2>
        <p className='Landing__cta__p'>{t('pages.index.landing.cta.p')}</p>
        <div className='Landing__cta__buttons'>
          <Link href='/contact'>
            <a className='Landing__cta__btn Landing__cta__btn--primary'>
              {t('pages.index.landing.cta.btn_primary')}
            </a>
          </Link>
          <Link href='/contact'>
            <a className='Landing__cta__btn Landing__cta__btn--outline'>
              {t('pages.index.landing.cta.btn_outline')}
            </a>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default CTA
